import AppRMAdmin from './app-rm-admin';
export default AppRMAdmin;